
import { cScene } from "../../cScene";
import { cGame } from "../../cGame";
import { Module } from "./Module";

export class State extends Module{

  private evName: string = ''
  private evModule?: string = ''
  private stateObj: any

  init() {     
    var $this = this;
    if (this.data.states){

      const onStateChange = (nm:string) => {
        if (nm === ($this.evModule+$this.evName) ){
          $this.handleState()
        }
      }

      setTimeout(()=>{
        if (this.data.statename){
          this.evName = this.data.statename
        }else{
          this.evName = (this.ref.scene as cScene).sceneData.options.name + '_' + this.ref.name
        }

        this.evModule = this.data.statemodule ? this.data.statemodule+'::' : ''
        cGame.current.state.events.on('change', onStateChange,this);
        //cGame.current.currentScene.events.once('destroy',()=>{ cGame.current.state.events.off('change',onStateChange) })
        this.handleState();        
      },1)
    }
  }

  handleState() {
    var gState = cGame.current.state.get(this.evModule + this.evName)
    var $this = this;

    if (this.ref && this.ref.scene && (this.ref.scene as cScene).debugMode) return

    //console.log('STATE',this.evModule + this.evName,gState)

    if (this.data.states[gState]){
      var obj = JSON.parse(this.data.states[gState])
      Object.keys(obj).forEach( (key)=>{
        ($this.ref as any)[key] = obj[key];
      })
      //console.log(obj)
    }
  }

  refresh(){

  }
}
